import { Component } from '@angular/core';

@Component({
  selector: 'pfx-global-search-overlay',
  imports: [],
  templateUrl: './global-search-overlay.component.html',
  styleUrl: './global-search-overlay.component.scss',
})
export class GlobalSearchOverlayComponent {}
